import React, {useState, useEffect} from 'react';
import { Subfolder } from '../ReactGlobals.js';
import moment from 'moment';
import {NavLink, matchPath, useLocation} from "react-router-dom";

const RagnaSidebar = props => {
    const {routes,action,controller} = props;
    const [accordionOpen, setAccordionOpen] = useState([]);
    const location = useLocation();

    useEffect(_=>{
        var arr = [];
        var accordionCount = routes.filter(route=>!route.IsHeader && route.Children != null).forEach(element => {
            arr.push(location.pathname.startsWith("/"+element.URL));
        });
        setAccordionOpen(arr);
    },[]);

    var accordionCounter = 0;
    return <>
        <ul className="nav nav-pills flex-column" data-widget="treeview" role="menu" data-accordion="false">
            {
                routes.map((navItem, i) => {
                    if (navItem.Name == null) {
                        return;
                    }
                    else if (navItem.IsHeader)
                    {
                        if (navItem.Access)
                            if (!props.access.some(item => navItem.Access.includes(parseInt(item)))) return <></>;

                        return <li className="nav-header" key={i}>{navItem.Name}</li>
                    }
                    else if (navItem.Children == null)
                    { 
                        if (navItem.Access)
                            if (!props.access.some(item => navItem.Access.includes(parseInt(item)))) return <></>;

                        return <li className={`nav-item ${navItem.IconClass==null?"no-icon":""}`} key={i}>
                            <NavLink to={navItem.URL} className={({ isActive, isPending }) =>
                                "nav-link " + (isActive
                                    ? "active"
                                    : isPending
                                    ? "pending"
                                    : "")
                                } >
                            {/* // ( isActive, isPending ) =>
                            //      "nav-link " + (isActive
                            //        ? "active"
                            //        : isPending
                            //        ? "pending"
                            //        : "")
                            //     } > */}
                                <i className={`nav-icon ${navItem.IconClass}`}></i>
                                <p className="text">{navItem.Name}</p>
                            </NavLink>
                        </li>
                    }
                    else
                    {
                        let currentCounter = accordionCounter;
                        accordionCounter++;
                        if (navItem.Access)
                            if (!props.access.some(item => navItem.Access.includes(parseInt(item)))) return <></>;
                        return <li className={`nav-item ${(location.pathname.startsWith("/"+navItem.URL) ? "menu-open" : "")}`} key={i}>
                            <a href="#" className={`nav-link ${(location.pathname.startsWith("/"+navItem.URL)?"active":"")} ${navItem.IconClass==""?"no-icon":""}`}
                            onClick={
                                _=>{
                                    setAccordionOpen(
                                        accordionOpen.map((isOpen,index)=>{
                                            if (index == currentCounter)
                                            {
                                                return !isOpen;
                                            }
                                            else
                                            {
                                                return isOpen;
                                            }
                                        })
                                    );
                                }
                            }>
                                <i className={`nav-icon ${navItem.IconClass}`}></i>
                                <p>
                                    {navItem.Name}
                                </p>
                                <i className={`right fas fa-angle-left ${accordionOpen[currentCounter]?"open":""}`}></i>
                            </a>
                            <ul className="nav nav-treeview" style={{maxHeight:accordionOpen[currentCounter]?1000:0}}>
                                {
                                    navItem.Children.map((_child, ii) =>
                                    {
                                        if (_child.Name == null) {
                                            return;
                                        }
                                        if (_child.Access)
                                            if (!props.access.some(item => _child.Access.includes(parseInt(item)))) return <></>;
                                        return <li className="nav-item" key={ii}>
                                            <NavLink to={navItem.URL+"/"+_child.URL}  className={({ isActive, isPending }) =>
                                                (_child.IconClass==null?"no-icon":"") + " nav-link " + (isActive
                                                    ? "active"
                                                    : isPending
                                                    ? "pending"
                                                    : "")
                                                }>
                                                <i className={`nav-icon ${_child.IconClass}`}></i>
                                                <p>{_child.Name}</p>
                                                {
                                                    _child.Children != null ?
                                                    <i className="right fas fa-angle-left"></i> : ""
                                                }
                                            </NavLink>
                                            {
                                                _child.Children != null ?
                                                <ul className="nav nav-treeview">
                                                {
                                                    _child.Children.map(
                                                        _subChild =>
                                                            {
                                                                //nav-link @((_childSec.URL.action == action) && (_childSec.URL.controller == controller) ? "active" : "")
                                                                <li className="nav-item">
                                                                    <NavLink to={_subChild.URL} className="">
                                                                        <i className={`nav-icon ${_subChild.IconClass}`}></i>
                                                                        <p>{_subChild.Name}</p>
                                                                    </NavLink>
                                                                </li>
                                                            }
                                                    )
                                                }
                                                </ul> : ""
                                            }
                                        </li>
                                    })
                                }
                            </ul>
                        </li>
                    }
                })
            }
        </ul>
    </>
}

export default RagnaSidebar;